<template>
  <div class="content-wrapper view-aptlist-manage p-0">
    <div class="content">
      <div class="card">
        <div class="card-body">
          <div class="header-topic">
            <h4>
              <svg
                width="18"
                height="20"
                viewBox="0 0 18 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.3125 2.91667H11.6667C11.6667 1.30794 10.3587 0 8.75 0C7.14128 0 5.83333 1.30794 5.83333 2.91667H2.1875C0.979818 2.91667 0 3.89648 0 5.10417V21.1458C0 22.3535 0.979818 23.3333 2.1875 23.3333H15.3125C16.5202 23.3333 17.5 22.3535 17.5 21.1458V5.10417C17.5 3.89648 16.5202 2.91667 15.3125 2.91667ZM8.75 1.82292C9.35612 1.82292 9.84375 2.31055 9.84375 2.91667C9.84375 3.52279 9.35612 4.01042 8.75 4.01042C8.14388 4.01042 7.65625 3.52279 7.65625 2.91667C7.65625 2.31055 8.14388 1.82292 8.75 1.82292ZM14.2734 12.3867L7.75651 18.849C7.54232 19.0632 7.19596 19.0586 6.98177 18.8444L3.21745 15.0482C3.00326 14.834 3.00781 14.4876 3.22201 14.2734L4.51628 12.9883C4.73047 12.7741 5.07682 12.7786 5.29102 12.9928L7.38737 15.1074L12.2181 10.3132C12.4323 10.099 12.7786 10.1035 12.9928 10.3177L14.278 11.612C14.4922 11.8307 14.4876 12.1725 14.2734 12.3867Z"
                  fill="currentColor"
                />
              </svg>
              การอนุมัติ
            </h4>
          </div>

          <b-card no-body>
            <b-tabs
              card
              v-model="activeTabIndex"
              @input="onTabChange"
            >
              <b-tab
                v-for="tab in statusTabs"
                :key="tab.status"
              >
                <template #title>
                  {{ tab.label }}{{ tab.showCount ? ` (${tab.count})` : "" }}
                  <span
                    v-if="tab.showRedDot && tab.count > 0"
                    class="tab-red-dot"
                  ></span>
                </template>
                <div
                  class="row"
                  style="margin: 0px 0px 20px 0px"
                >
                  <b-form-input
                    type="search"
                    class="col"
                    autofocus
                    v-model="filter"
                    placeholder="ค้นหาใบรับสินค้า หรือ การจัดการสต๊อก จากรหัส"
                  ></b-form-input>
                </div>
                <b-table
                  id="hqApprovalTable"
                  hover
                  small
                  sort-icon-left
                  :sort-by="'dateTimeStock'"
                  head-variant="light"
                  :items="filteredList"
                  :fields="fields"
                  :sort-desc="true"
                  :responsive="false"
                >
                  <template v-slot:cell(index)="row">
                    <div
                      class="d-flex align-items-center justify-content-center"
                    >
                      {{ row.index + 1 }}.
                    </div>
                  </template>
                  <template v-slot:cell(normalizedStatus)="row">
                    <AdjustmentStatusBadge
                      :status="row.item.normalizedStatus"
                    />
                  </template>
                  <template v-slot:cell(branchName)="row">
                    {{ row.item.branchName || row.item.branchUrl || "-" }}
                  </template>
                  <template v-slot:cell(adjNo)="row">
                    {{ row.item.adjNo }}
                  </template>
                  <template v-slot:cell(type)="row">
                    {{ row.item.type }}
                  </template>
                  <template v-slot:cell(button)="row">
                    <ActionButtonGroup
                      :item="row.item"
                      compact
                      :showEdit="false"
                      :showDelete="
                        row.item.normalizedStatus ===
                        ADJUSTMENT_STATUS.WAITING_HQ
                      "
                      :info-tooltip="row.item.itemType === 'GR' ? 'ดูข้อมูลใบรับสินค้า' : 'ดูข้อมูลการจัดการสต๊อก'"
                      :delete-tooltip="row.item.itemType === 'GR' ? 'ยกเลิกใบรับสินค้า' : 'ยกเลิกการจัดการสต๊อก'"
                      @info="goToDetail(row.item)"
                      @delete="handleDelete(row.item)"
                    />
                  </template>
                </b-table>
              </b-tab>
            </b-tabs>
          </b-card>
        </div>
      </div>
      <Dialog ref="Dialog"></Dialog>
      <Loading v-if="isLoading"></Loading>
    </div>
  </div>
</template>

<script>
import Loading from "@/components/Loading";
import Dialog from "@/components/modal/Dialog.vue";
import AdjustmentStatusBadge from "@/components/badge/ProductAndStock/AdjustmentStatusBadge.vue";
import ActionButtonGroup from "@/components/table/stock/button/ActionButtons.vue";
import { ADJUSTMENT_STATUS, STOCK_TYPE_NAME } from "@/constants/productStock";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { formatDate } from "@/utils/utils";

export default {
  name: "HQApproval",
  components: {
    Loading,
    Dialog,
    AdjustmentStatusBadge,
    ActionButtonGroup,
  },
  data() {
    const tabStatusMap = {
      WAITING_HQ: 0,
      COMPLETED_HQ: 1,
      REJECTED: 2,
      CANCELED: 3,
    };
    const savedTab = sessionStorage.getItem("hqApprovalTab");
    return {
      ADJUSTMENT_STATUS,
      isLoading: false,
      filter: "",
      activeTabIndex: tabStatusMap[savedTab] ?? 0,
    };
  },
  async mounted() {
    await this.init();
  },
  computed: {
    ...mapGetters({
      getHQStockAdjustmentList:
        "moduleProductInventory/getHQStockAdjustmentList",
      getHQGoodsReceiveList: "moduleGoodsReceive/getHQGoodsReceiveList",
    }),
    fields() {
      return [
        { key: "index", label: "", thStyle: { width: "5%" } },
        { key: "normalizedStatus", label: "สถานะ", thStyle: { width: "16%" } },
        {
          key: "branchName",
          label: "สาขา",
          sortable: true,
          thStyle: { width: "16%" },
        },
        {
          key: "adjNo",
          label: "รหัส",
          sortable: true,
          thStyle: { width: "14%" },
        },
        {
          key: "type",
          label: "ประเภท",
          sortable: true,
          thStyle: { width: "16%" },
        },
        {
          key: "dateTimeStock",
          label: "วันที่ทำรายการ",
          sortable: true,
          formatter: value => (value ? formatDate(value) : ""),
          thStyle: { width: "14%", whiteSpace: "nowrap" },
        },
        {
          key: "button",
          label: "",
          class: "text-center",
          thStyle: { width: "8%", whiteSpace: "nowrap" },
        },
      ];
    },
    sortedList() {
      const adjustments = (this.getHQStockAdjustmentList || []).map(item => ({
        ...item,
        itemType: "ADJUSTMENT",
        normalizedStatus: this.normalizeAdjStatus(item.status),
        managedByStock: [
          item.creationUser?.firstNameTh,
          item.creationUser?.lastNameTh,
        ]
          .filter(Boolean)
          .join(" "),
        dateTimeStock: item.creationDt || "",
        type: this.getAdjustmentDetail(item.type),
        rawType: item.type,
      }));

      const grItems = (this.getHQGoodsReceiveList || []).map(item => ({
        ...item,
        itemType: "GR",
        normalizedStatus: item.status,
        adjNo: item.grNo,
        type: "ใบรับสินค้า",
        rawType: "GR",
        dateTimeStock: item.creationDt || "",
      }));

      return [...adjustments, ...grItems].sort(
        (a, b) => new Date(b.creationDt) - new Date(a.creationDt)
      );
    },
    statusTabs() {
      const hqCompletedItems = this.sortedList.filter(
        i =>
          i.normalizedStatus === ADJUSTMENT_STATUS.COMPLETED &&
          this.isHqApprovedItem(i)
      );
      return [
        {
          status: "WAITING_HQ",
          label: "รออนุมัติ",
          showCount: true,
          showRedDot: true,
          count: this.sortedList.filter(
            i => i.normalizedStatus === ADJUSTMENT_STATUS.WAITING_HQ
          ).length,
        },
        {
          status: "COMPLETED_HQ",
          label: "อนุมัติแล้ว",
          showCount: false,
          showRedDot: false,
          count: hqCompletedItems.length,
        },
        {
          status: "REJECTED",
          label: "ถูกปฏิเสธ",
          showCount: false,
          showRedDot: false,
          count: this.sortedList.filter(
            i => i.normalizedStatus === ADJUSTMENT_STATUS.REJECTED
          ).length,
        },
        {
          status: "CANCELED",
          label: "ถูกยกเลิก",
          showCount: false,
          showRedDot: false,
          count: this.sortedList.filter(
            i => i.normalizedStatus === ADJUSTMENT_STATUS.CANCELED
          ).length,
        },
      ];
    },
    activeTabStatus() {
      const statuses = ["WAITING_HQ", "COMPLETED_HQ", "REJECTED", "CANCELED"];
      return statuses[this.activeTabIndex] || "WAITING_HQ";
    },
    filteredList() {
      const byStatus =
        this.activeTabStatus === "COMPLETED_HQ"
          ? this.sortedList.filter(
              i =>
                i.normalizedStatus === ADJUSTMENT_STATUS.COMPLETED &&
                this.isHqApprovedItem(i)
            )
          : this.sortedList.filter(
              i => i.normalizedStatus === this.activeTabStatus
            );

      const keyword = (this.filter || "").trim().toLowerCase();
      if (!keyword) return byStatus;
      return byStatus.filter(i =>
        (i.adjNo || "").toLowerCase().includes(keyword)
      );
    },
  },
  methods: {
    ...mapActions({
      fetchHQStockAdjustmentList:
        "moduleProductInventory/fetchHQStockAdjustmentList",
      deleteStockAdjustmentAction:
        "moduleProductInventory/deleteStockAdjustment",
      deleteGoodsReceiveAction:
        "moduleGoodsReceive/deleteGoodsReceive",
    }),
    ...mapMutations({
      removeHQStockAdjustment: "moduleProductInventory/removeHQStockAdjustment",
      removeHQGoodsReceive: "moduleGoodsReceive/removeHQGoodsReceive",
    }),
    async init() {
      this.isLoading = true;
      try {
        const { clinicUrl } = this.$route.params;
        await this.fetchHQStockAdjustmentList({ clinicUrl });
      } catch (err) {
        this.$refs.Dialog.showToast("danger", "โหลดข้อมูลไม่สำเร็จ");
        console.error(err);
      } finally {
        this.isLoading = false;
      }
    },
    onTabChange(index) {
      const keys = ["WAITING_HQ", "COMPLETED_HQ", "REJECTED", "CANCELED"];
      sessionStorage.setItem("hqApprovalTab", keys[index] || "WAITING_HQ");
    },
    normalizeAdjStatus(status) {
      const remap = { PENDING: "WAITING_BM", CONFIRMED: "COMPLETED" };
      return remap[status] || status || "";
    },
    isHqApprovedItem(item) {
      const t = item.rawType;
      if (t === STOCK_TYPE_NAME.GENERAL || t === STOCK_TYPE_NAME.PHYSICAL_COUNT) return true;
      const tDate = item.transactionDt
        ? new Date(item.transactionDt).toDateString()
        : null;
      const cDate = item.creationDt
        ? new Date(item.creationDt).toDateString()
        : null;
      return tDate !== cDate;
    },
    getAdjustmentDetail(docType) {
      switch (docType) {
        case STOCK_TYPE_NAME.GENERAL:
          return "ปรับปรุงทั่วไป";
        case STOCK_TYPE_NAME.RETURN:
          return "ส่งคืนสินค้า";
        case STOCK_TYPE_NAME.PHYSICAL_COUNT:
          return "ตรวจนับสต๊อก";
        case STOCK_TYPE_NAME.WITHDRAW:
          return "ตัดเบิกของ";
        default:
          return docType || "-";
      }
    },
    async handleDelete(item) {
      if (!item.branchUrl) return;
      const isGR = item.itemType === "GR";
      const result = await this.$refs.Dialog.showAlertConfirm(
        isGR ? "ยกเลิกใบรับสินค้า ?" : "ยกเลิกการจัดการสต๊อก ?",
        isGR
          ? "คุณต้องการยกเลิกใบรับสินค้านี้ใช่หรือไม่"
          : "คุณต้องการยกเลิกการจัดการสต๊อกนี้ใช่หรือไม่"
      );
      if (!result.value) return;
      this.isLoading = true;
      try {
        if (item.itemType === "GR") {
          await this.deleteGoodsReceiveAction({
            clinicUrl: this.$route.params.clinicUrl,
            branchUrl: item.branchUrl,
            id: item.id,
          });
          this.removeHQGoodsReceive({ id: Number(item.id) });
          this.$refs.Dialog.showToast("success", "ยกเลิกใบรับสินค้าสำเร็จ");
        } else {
          await this.deleteStockAdjustmentAction({
            clinicUrl: this.$route.params.clinicUrl,
            branchUrl: item.branchUrl,
            adjustmentId: item.id,
          });
          this.removeHQStockAdjustment({ id: Number(item.id) });
          this.$refs.Dialog.showToast("success", "ยกเลิกการจัดการสต๊อกสำเร็จ");
        }
      } catch (err) {
        const errorMessage = err.response?.data?.errorMessage;
        this.$refs.Dialog.showToast(
          "danger",
          typeof errorMessage === "string"
            ? errorMessage
            : item.itemType === "GR"
              ? "ยกเลิกใบรับสินค้าไม่สำเร็จ กรุณาลองใหม่"
              : "ยกเลิกการจัดการสต๊อกไม่สำเร็จ กรุณาลองใหม่"
        );
      } finally {
        this.isLoading = false;
      }
    },
    goToDetail(item) {
      if (!item.branchUrl) return;
      if (item.itemType === "GR") {
        this.$router.push({
          name: "HQApprovalGRDetail",
          params: {
            clinicUrl: this.$route.params.clinicUrl,
            branch: item.branchUrl,
            grId: item.id,
          },
        });
        return;
      }
      this.$router.push({
        name: "HQApprovalDetail",
        params: {
          clinicUrl: this.$route.params.clinicUrl,
          branch: item.branchUrl,
          adjustmentId: item.id,
        },
      });
    },
  },
};
</script>

<style scoped>
.header-topic {
  display: flex;
  gap: 8px;
  align-items: center;
  margin-bottom: 16px;
}

.tab-red-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  background-color: #dd3333;
  border-radius: 50%;
  vertical-align: center;
}

.ellipsis-text {
  display: block;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

::v-deep #hqApprovalTable {
  table-layout: fixed;
  width: 100%;
}

::v-deep #hqApprovalTable thead tr th,
::v-deep #hqApprovalTable tbody tr td {
  vertical-align: middle !important;
}

::v-deep #hqApprovalTable td {
  padding: 16px 24px !important;
  word-break: break-word !important;
  white-space: normal !important;
}

::v-deep #hqApprovalTable th {
  padding: 16px 24px !important;
  word-break: break-word !important;
  white-space: normal !important;
}

::v-deep #hqApprovalTable th {
  white-space: nowrap;
}
</style>
